import './style.scss'
import { useState } from 'react'
import { 
    AbsoluteContainer,
    Button,
    CustomContainer, FlexRow, Form, FormGroup, FormGroupWithIcon, ReactSelect, SidePopupContainer
} from "src/style"
import helpers from 'src/utils/helpers'
import { FiChevronDown } from 'react-icons/fi'
import utility, { handleTypeNumberControl } from 'src/utils/utility'
import { useTranslation } from 'react-i18next'

export const ReportFilter: React.FC<any> = ({type, setFilterData, onApplyFilter, top, close, surveyTriggerList}) => {
    const { t } = useTranslation();
    const [input, setInput] = useState<any>({
        startDateTime: null, endDateTime: null, customerName: null, customerId: null, 
        category: null, accountNumber: null, network: null, firstName: null, lastName: null,
        username: null, isMobile: null, isSuccessful: null, amount: null, profileID: null,
        model: null, role: null, institutionCode: null, name: null, alias: null,
        onboardingMethod: null, status: null, statusMessage: null, FromDate: null, 
        ToDate: null, userID : null, action :null, bvn:null, surveyTriggerId:null, 
        fullName: null, email: null, phoneNumber: null
    })

    let hasCustomerName = ['transfer', 'airtime', 'bill-payment', 'fixed-deposit', 'target-savings', 'account-upgarde']
    let hasCustomerId = ['transfer', 'airtime', 'bill-payment', 'customer-profile', 'fixed-deposit', 'target-savings', 'loans', 'account-upgarde','cbp-report','cbp-customer']
    let hasAccountNumber = ['transfer', 'customer-profile', 'failed-transactions', 'transaction-limit', 'loans', 'account-upgarde','cbp-report']
    let hasAmount = ['failed-transactions']
    let hasProfileID = ['failed-transactions', 'transaction-limit']
    let hasFirstAndLastName = ['customer-profile', 'users']
    let hasUsername = ['customer-login', 'login-report', 'users','customer-profile']
    let noDateRange = ['build', 'cbp-customer']
    let hasInstitutionCode = ['institutions', 'users']
    let hasStatus = ['account-upgarde','loans']
    let hasDropdownStatus =['cbp-customer']
    let hasUserId = ['audit-report']
    let hasBvn = ['customer-profile']
    let hasPhoneNumber = ['account-request']
    let hasEmail = ['account-request']
    let hasFullname = ['account-request']

    const cbpCustomerStatus = [
        {label: t('reportFilter.statusOptions.submitted'), value:'submitted'},
        {label: t('reportFilter.statusOptions.approved'), value:'approved'},
        {label: t('reportFilter.statusOptions.indemnityRejected'), value:'indemnityRejected'},
        {label: t('reportFilter.statusOptions.indemnityApproved'), value:'indemnityApproved'},
        {label: t('reportFilter.statusOptions.ongoingAmlScreening'), value:'ongoingAmlScreening'},
        {label: t('reportFilter.statusOptions.amlScreeningPassed'), value:'AmlScreeningPassed'},
        {label: t('reportFilter.statusOptions.amlScreeningFailed'), value:'AmlScreeningFailed'}
    ]

    const handleInput = (e: React.ChangeEvent<HTMLInputElement|HTMLTextAreaElement|HTMLSelectElement>) => {
        if(e.target.name === 'id'){
            setInput({...input, [e.target.name]: Number(e.target.value)})
        }else if(e.target.name === 'userID'){
            setInput({...input, [e.target.name]: Number(e.target.value)})
        }
        else{
            setInput({...input, [e.target.name]: e.target.value})
        }
    }

    async function handleSubmit(e: React.FormEvent<HTMLButtonElement | HTMLFormElement>) {
        e.preventDefault()
        const isMobile = input.isMobile == t('reportFilter.platformOptions.mobile') ? true : input.isMobile == t('reportFilter.platformOptions.web') ? false : null
        const isSuccessful = input.isSuccessful == t('reportFilter.statusOptions.success') ? true : input.isSuccessful == t('reportFilter.statusOptions.failed') ? false : null

        await setFilterData({...input, isMobile, isSuccessful}) 
        onApplyFilter()
        close()
    }
    
    return (
        <>
            <SidePopupContainer zIndex="7" onClick={close} bgColor='rgba(0,0,0, 0.06)' />
            <AbsoluteContainer 
                zIndex="8" 
                top={top || '34'} 
                right='11' 
                className={top ? "report-filter-container-plus" : "report-filter-container"}
            >
                <CustomContainer
                    width="36"
                    bgColor="#ffffff"
                    padding="2" radius="1"
                    shadow="0px 4px 10px 0px #0000000D"
                    className='report-content-container'
                >
                    <Form onSubmit={handleSubmit}>
                        { !noDateRange.includes(type) &&
                            <FlexRow 
                                justifyContent='space-between' gap='4' sizeUnit='%'
                                className='report-input-row'
                            >
                                <FormGroup bottomMargin='0' height='4'>
                                    <label>{t('reportFilter.startDate')}</label>
                                    <input 
                                        name={type === 'loans' ? 'createdStartDateTime' : type === 'cbp-report' ? 'FromDate' :'startDateTime'}
                                        type='date'
                                        max={helpers.getInputValidDate()}
                                        style={{color: input.startDateTime ? '#000000' : '#667085'}}
                                        value={type === 'cbp-report' ? input.FromDate : input.startDateTime}
                                        onChange={handleInput}
                                        autoComplete="off"
                                    />
                                </FormGroup>
                                <FormGroup bottomMargin='0'  height='4'>
                                    <label>{t('reportFilter.endDate')}</label>
                                    <input 
                                        name={type === 'loans' ? 'createdEndDateTime' : type === 'cbp-report' ? 'ToDate' : 'endDateTime'}
                                        type='date'
                                        max={helpers.getInputValidDate()}
                                        style={{color: input.endDateTime ? '#000000' : '#667085'}}
                                        value={type === 'cbp-report' ? input.ToDate : input.endDateTime}
                                        onChange={handleInput}
                                        autoComplete="off"
                                    />
                                </FormGroup>
                            </FlexRow>
                        }
                           
                        { hasFullname.includes(type) &&
                            <FormGroup height='4'>
                                <label>{t('reportFilter.fullName')}</label>
                                <input 
                                    placeholder={t('reportFilter.placeholders.enterName')}
                                    name='fullName'
                                    value={input.fullName}
                                    onChange={handleInput}
                                    autoComplete="off"
                                />
                            </FormGroup>
                        }

                         { hasEmail.includes(type) &&
                            <FormGroup height='4'>
                                <label>{t('reportFilter.email')}</label>
                                <input 
                                    placeholder={t('reportFilter.placeholders.enterEmail')}
                                    name='email'
                                    value={input.email}
                                    onChange={handleInput}
                                    autoComplete="off"
                                />
                            </FormGroup>
                        }

                        { hasPhoneNumber.includes(type) &&
                            <FormGroup height='4'>
                                <label>{t('reportFilter.phone')}</label>
                                <input 
                                    placeholder={t('reportFilter.placeholders.enterPhonNumber')}
                                    name='phoneNumber'
                                    value={input.phoneNumber}
                                    onChange={handleInput}
                                    autoComplete="off"
                                />
                            </FormGroup>
                        }

                        { hasCustomerId.includes(type) &&
                            <FormGroup height='4'>
                                <label>{type === 'cbp-report' ? t('reportFilter.profileId') : t('reportFilter.customerId')}</label>
                                <input 
                                    placeholder={type === 'cbp-report' ? t('reportFilter.placeholders.enterProfileId') : t('reportFilter.placeholders.enterCustomerId')}
                                    name={type === 'cbp-report' ? 'ProfileId':'customerId'}
                                    value={ type === 'cbp-report' ? input.profileID :input.customerId}
                                    onChange={handleInput}
                                    autoComplete="off"
                                />
                            </FormGroup>
                        }
                        { hasUserId.includes(type) &&
                            <>
                                <FormGroup height='4'>
                                    <label>{t('reportFilter.userId')}</label>
                                    <input
                                        placeholder={t('reportFilter.placeholders.enterUserId')}
                                        name='userID'
                                        value={input.userID}
                                        onChange={handleInput}
                                        autoComplete="off"
                                    />
                                </FormGroup>
                                <FormGroup height='4'>
                                    <label>{t('reportFilter.action')}</label>
                                    <input
                                        placeholder={t('reportFilter.placeholders.enterAction')}
                                        name='action'
                                        value={input.action}
                                        onChange={handleInput}
                                        autoComplete="off"
                                    />
                                </FormGroup>
                            </>
                        }
                        { type === 'bill-payment' &&
                            <FormGroupWithIcon >
                                <label>{t('reportFilter.category')}</label>
                                <div className="input-with-icon" style={{height: '4rem'}}>
                                    <select
                                        name='category'
                                        value={input.category}
                                        style={{color: input.category ? '#000000' : '#667085'}}
                                        onChange={handleInput}
                                        autoComplete="off"
                                    >
                                        <option value="">{t('reportFilter.selectCategory')}</option>
                                        <option value="Admin">{t('reportFilter.categoryOptions.admin')}</option>
                                        <option value="User">{t('reportFilter.categoryOptions.user')}</option>
                                    </select>
                                    <FiChevronDown className="input-with-icon-tag" />
                                </div>
                            </FormGroupWithIcon>
                        }
                        { hasAccountNumber.includes(type) &&
                            <FormGroup height='4'>
                                <label>{t('reportFilter.accountNumber')}</label>
                                <input 
                                    placeholder={t('reportFilter.placeholders.enterAccountNumber')}
                                    name={type === 'loans' ? 'loanAccountNumber' : 'accountNumber'}
                                    value={input.accountNumber}
                                    onChange={handleInput}
                                    autoComplete="off"
                                />
                            </FormGroup>   
                        }
                        { type === 'airtime' &&
                            <FormGroupWithIcon >
                                <label>{t('reportFilter.network')}</label>
                                <div className="input-with-icon" style={{height: '4rem'}}>
                                    <select
                                        name='network'
                                        value={input.network}
                                        style={{color: input.network ? '#000000' : '#667085'}}
                                        onChange={handleInput}
                                        autoComplete="off"
                                    >
                                        <option value="">{t('reportFilter.selectNetwork')}</option>
                                        <option value="MTN">MTN</option>
                                        <option value="GLO">GLO</option>
                                        <option value="AIRTEL">AIRTEL</option>
                                        <option value="ETISALAT">ETISALAT</option>
                                    </select>
                                    <FiChevronDown className="input-with-icon-tag" />
                                </div>
                            </FormGroupWithIcon>
                        }
                        { hasFirstAndLastName.includes(type) &&
                            <>
                                <FormGroup height='4'>
                                    <label>{t('reportFilter.firstName')}</label>
                                    <input 
                                        placeholder={t('reportFilter.placeholders.enterFirstName')}
                                        name='firstName'
                                        value={input.firstName}
                                        onChange={handleInput}
                                        autoComplete="off"
                                    />
                                </FormGroup>   
                                <FormGroup height='4'>
                                    <label>{t('reportFilter.lastName')}</label>
                                    <input 
                                        placeholder={t('reportFilter.placeholders.enterLastName')}
                                        name='lastName'
                                        value={input.lastName}
                                        onChange={handleInput}
                                        autoComplete="off"
                                    />
                                </FormGroup>   
                            </>
                        }
                        { hasUsername.includes(type) &&
                            <FormGroup height='4'>
                                <label>{t('reportFilter.username')}</label>
                                <input 
                                    placeholder={t('reportFilter.placeholders.enterUsername')}
                                    name='username'
                                    value={input.username}
                                    onChange={handleInput}
                                    autoComplete="off"
                                />
                            </FormGroup> 
                        }

                        { hasBvn.includes(type) &&
                            <FormGroup height='4'>
                                <label>BVN</label>
                                <input
                                    placeholder='Enter bvn'
                                    name='bvn'
                                    value={input.bvn}
                                    onChange={handleInput}
                                    autoComplete="off"
                                />
                            </FormGroup>
                        }
                        { ['login-report', 'customer-login'].includes(type) &&
                            <>
                                { type === 'customer-login' &&
                                    <FormGroupWithIcon >
                                        <label>{t('reportFilter.platform')}</label>
                                        <div className="input-with-icon" style={{height: '4rem'}}>
                                            <select 
                                                name='isMobile'
                                                value={input.isMobile}
                                                style={{color: input.isMobile ? '#000000' : '#667085'}}
                                                onChange={handleInput}
                                                autoComplete="off"
                                            >
                                                <option value="">{t('reportFilter.selectType')}</option>
                                                <option value={t('reportFilter.platformOptions.mobile')}>{t('reportFilter.platformOptions.mobile')}</option>
                                                <option value={t('reportFilter.platformOptions.web')}>{t('reportFilter.platformOptions.web')}</option>
                                            </select>
                                            <FiChevronDown className="input-with-icon-tag" />
                                        </div>
                                    </FormGroupWithIcon>
                                }
                                <FormGroupWithIcon >
                                    <label>{t('reportFilter.loginStatus')}</label>
                                    <div className="input-with-icon" style={{height: '4rem'}}>
                                        <select 
                                            name='isSuccessful'
                                            value={input.isSuccessful}
                                            style={{color: input.isSuccessful ? '#000000' : '#667085'}}
                                            onChange={handleInput}
                                            autoComplete="off"
                                        >
                                            <option value="">{t('reportFilter.selectStatus')}</option>
                                            <option value={t('reportFilter.statusOptions.success')}>{t('reportFilter.statusOptions.success')}</option>
                                            <option value={t('reportFilter.statusOptions.failed')}>{t('reportFilter.statusOptions.failed')}</option>
                                        </select>
                                        <FiChevronDown className="input-with-icon-tag" />
                                    </div>
                                </FormGroupWithIcon>
                            </>
                        }
                        { hasAmount.includes(type) &&
                            <FormGroup height='4'>
                                <label>{t('reportFilter.amount')}</label>
                                <input 
                                    placeholder={t('reportFilter.placeholders.enterAmount')}
                                    name='amount'
                                    value={input.amount}
                                    onChange={handleInput}
                                    onKeyDown={handleTypeNumberControl}
                                    onKeyUp={handleTypeNumberControl}
                                    autoComplete="off"
                                />
                            </FormGroup> 
                        }
                        { hasProfileID.includes(type) &&
                            <FormGroup height='4'>
                                <label>{t('reportFilter.profileId')}</label>
                                <input 
                                    placeholder={t('reportFilter.placeholders.enterProfileId')}
                                    name='profileID'
                                    value={input.profileID}
                                    onChange={handleInput}
                                    autoComplete="off"
                                />
                            </FormGroup> 
                        }
                        { type === 'customer-profile' &&
                            <FormGroupWithIcon >
                                <label>{t('reportFilter.onboardingMethod')}</label>
                                <div className="input-with-icon" style={{height: '4rem'}}>
                                    <select 
                                        name='onboardingMethod'
                                        value={input.onboardingMethod}
                                        style={{color: input.onboardingMethod ? '#000000' : '#667085'}}
                                        onChange={handleInput}
                                        autoComplete="off"
                                    >
                                        <option value="">{t('reportFilter.selectMethod')}</option>
                                        <option value='NewCustomer'>{t('reportFilter.onboardingOptions.newCustomer')}</option>
                                        <option value="ExistingCustomer">{t('reportFilter.onboardingOptions.existingCustomer')}</option>
                                        <option value="V1Migration">{t('reportFilter.onboardingOptions.v1Migration')}</option>
                                    </select>
                                    <FiChevronDown className="input-with-icon-tag" />
                                </div>
                            </FormGroupWithIcon>
                        }
                        { type === 'audit-report' &&
                            <FormGroup height='4'>
                                <label>{t('reportFilter.model')}</label>
                                <input 
                                    placeholder={t('reportFilter.placeholders.enterModel')}
                                    name='model'
                                    value={input.model}
                                    onChange={handleInput}
                                    autoComplete="off"
                                />
                            </FormGroup> 
                        }
                        { type === 'build' &&
                            <FormGroup height='4'>
                                <label>{t('reportFilter.buildType')}</label>
                                <div className="input-with-icon" style={{height: '4rem'}}>
                                    <select 
                                        name='buildType'
                                        value={input.buildType}
                                        style={{color: input.buildType ? '#000000' : '#667085'}}
                                        onChange={handleInput}
                                        autoComplete="off"
                                    >
                                        <option value="">{t('reportFilter.selectBuildType')}</option>
                                        <option value='APK'>APK</option>
                                        <option value="AAB">AAB</option>
                                    </select>
                                    <FiChevronDown className="input-with-icon-tag" />
                                </div>
                            </FormGroup> 
                        }
                        { type === 'users' &&
                            <FormGroupWithIcon >
                                <label>{t('reportFilter.role')}</label>
                                <div className="input-with-icon" style={{height: '4rem'}}>
                                    <select 
                                        name='role'
                                        value={input.role}
                                        style={{color: input.role ? '#000000' : '#667085'}}
                                        onChange={handleInput}
                                        autoComplete="off"
                                    >
                                        <option value="">{t('reportFilter.selectRole')}</option>
                                        <option value='SA'>{t('reportFilter.roleOptions.qoreAdmin')}</option>
                                        <option value="Admin">{t('reportFilter.roleOptions.institutionAdmin')}</option>
                                        <option value="User">{t('reportFilter.roleOptions.institutionUser')}</option>
                                    </select>
                                    <FiChevronDown className="input-with-icon-tag" />
                                </div>
                            </FormGroupWithIcon>
                        }
                        { hasInstitutionCode.includes(type) &&
                            <FormGroup height='4'>
                                <label>{t('reportFilter.institutionCode')}</label>
                                <input 
                                    placeholder={t('reportFilter.placeholders.enterCode')}
                                    name='institutionCode'
                                    value={input.institutionCode}
                                    onChange={handleInput}
                                    autoComplete="off"
                                />
                            </FormGroup> 
                        }
                        { type === 'institutions' &&
                            <>
                                <FormGroup height='4'>
                                    <label>{t('reportFilter.institutionName')}</label>
                                    <input 
                                        placeholder={t('reportFilter.placeholders.enterName')}
                                        name='name'
                                        value={input.name}
                                        onChange={handleInput}
                                        autoComplete="off"
                                    />
                                </FormGroup> 
                                <FormGroup height='4'>
                                    <label>{t('reportFilter.ibInstitutionCode')}</label>
                                    <input 
                                        placeholder={t('reportFilter.placeholders.enterName')}
                                        name='id'
                                        value={input.id}
                                        onChange={handleInput}
                                        autoComplete="off"
                                    />
                                </FormGroup> 
                                <FormGroup height='4'>
                                    <label>{t('reportFilter.alias')}</label>
                                    <input 
                                        placeholder={t('reportFilter.placeholders.enterAlias')}
                                        name='alias'
                                        value={input.alias}
                                        onChange={handleInput}
                                        autoComplete="off"
                                    />
                                </FormGroup> 
                            </>
                        }
                        { hasStatus.includes(type) &&
                            <FormGroup height='4'>
                                <label>{t('reportFilter.status')}</label>
                                <input 
                                    placeholder={t('reportFilter.placeholders.enterStatus')}
                                    name='status'
                                    value={input.status}
                                    onChange={handleInput}
                                    autoComplete="off"
                                />
                            </FormGroup> 
                        }
                        {
                            hasDropdownStatus.includes(type) &&
                            <ReactSelect
                                bottomMargin="1.5" topMargin="1"
                                styles={utility.reactSelectStyles()}
                                options={
                                    cbpCustomerStatus?.map((item: any, index: number) => {
                                        return {
                                            label: item.label,
                                            value: item.value,
                                            key: index
                                        }
                                    })
                                }
                                isClearable={true}
                                isSearchable={true}
                                name='status'
                                placeholder={t('reportFilter.selectStatus')}
                                menuPortalTarget={document.body} 
                                value={cbpCustomerStatus?.find(option => option.value === input.status) || null}
                                onChange={(e:any)=>{
                                    setInput((prev:any) =>({...prev,status:e?e.value : ""}))
                                }}
                            />
                        }
                        { type === 'build' &&
                        <>
                            <FlexRow 
                                justifyContent='space-between' gap='4' sizeUnit='%'
                                className='report-input-row'
                            >
                                <FormGroup bottomMargin='0' height='4'>
                                    <label>{t('reportFilter.startDate')}</label>
                                    <input 
                                        name='lastBuildStartDateTime'
                                        type='date'
                                        max={helpers.getInputValidDate()}
                                        style={{color: input.lastBuildEndDateTime ? '#000000' : '#667085'}}
                                        value={input.lastBuildStartDateTime}
                                        onChange={handleInput}
                                        autoComplete="off"
                                    />
                                </FormGroup>
                                <FormGroup bottomMargin='0'  height='4'>
                                    <label>{t('reportFilter.endDate')}</label>
                                    <input 
                                        name='lastBuildEndDateTime'
                                        type='date'
                                        max={helpers.getInputValidDate()}
                                        style={{color: input.lastBuildEndDateTime ? '#000000' : '#667085'}}
                                        value={input.lastBuildEndDateTime}
                                        onChange={handleInput}
                                        autoComplete="off"
                                    />
                                </FormGroup>
                            </FlexRow>
                            <FormGroup height='4'>
                                <label>{t('reportFilter.institutionName')}</label>
                                <input 
                                    placeholder={t('reportFilter.placeholders.enterInstitutionName')}
                                    name='institutionName'
                                    value={input.institutionName}
                                    onChange={handleInput}
                                    autoComplete="off"
                                />
                            </FormGroup> 
                            <FormGroup height='4'>
                                <label>{t('reportFilter.status')}</label>
                                <input 
                                    placeholder={t('reportFilter.placeholders.enterStatus')}
                                    name='statusMessage'
                                    value={input.statusMessage}
                                    onChange={handleInput}
                                    autoComplete="off"
                                />
                            </FormGroup> 
                            <FormGroup height='4'>
                                <label>{t('reportFilter.versionCode')}</label>
                                <input 
                                    placeholder={t('reportFilter.placeholders.enterVersionCode')}
                                    name='versionCode'
                                    value={input.versionCode}
                                    onChange={handleInput}
                                    autoComplete="off"
                                />
                            </FormGroup> 
                            <FormGroup height='4'>
                                <label>{t('reportFilter.packageName')}</label>
                                <input 
                                    placeholder={t('reportFilter.placeholders.enterPackageName')}
                                    name='packageName'
                                    value={input.packageName}
                                    onChange={handleInput}
                                    autoComplete="off"
                                />
                            </FormGroup> 
                        </>
                        }

                        { type === 'survey' &&
                            <FormGroupWithIcon >
                                <label>Survey Type</label>
                                <div className="input-with-icon" style={{height: '4rem'}}>
                                    <select
                                        placeholder="Select survey type"
                                        name='surveyTriggerId'
                                        value={input.surveyTriggerId}
                                        style={{color: input.category ? '#000000' : '#667085'}}
                                        onChange={handleInput}
                                        autoComplete="off"
                                    >
                                        <option value="">Select survey type</option>
                                        {surveyTriggerList?.map((item:any, index:number)=>
                                            <option key={index} value={item.value}>{item.label}</option>
                                        )}
                                    </select>
                                    <FiChevronDown className="input-with-icon-tag" />
                                </div>
                            </FormGroupWithIcon>
                        }
                        <Button
                            width='11.2' height='4' topMargin='1'
                            borderColor='#0D968F' hoverBgColor='#fff' 
                            hoverColor='#0D968F' titleSize='1.4'
                        >
                            {t('reportFilter.applyFilter')}
                        </Button>
                    </Form>
                </CustomContainer>
            </AbsoluteContainer>
        </>
    )
}